import { useMemo } from 'react';
import { GuidedTourShell } from '../../components/onboarding/GuidedTourShell';
import { buildCustomerTourSteps } from '../../onboarding/customerTourSteps';
import { usePortalModules } from './portalModules';
import { completeCustomerTour } from '../../lib/api.customer';

const STORAGE_KEY = 'customerportal.tour.completed';
const OPEN_EVENT = 'customerportal:start-tour';

/** Von überall im Kundenportal startbar — z. B. aus der Hilfe-Seite. */
export function startCustomerGuidedTour(): void {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

export function hasCompletedCustomerTour(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Geführter Rundgang durchs Kundenportal.
 *
 * Der Abschluss wird zusätzlich serverseitig vermerkt (`tourCompletedAt`), damit er
 * auch auf einem anderen Gerät als erledigt gilt — Kunden melden sich typischerweise
 * mal am Rechner, mal am Telefon an. Schlägt das fehl, ist das kein Grund, den
 * Rundgang scheitern zu lassen: der lokale Merker greift trotzdem.
 */
export function CustomerGuidedTour() {
  // Nur freigeschaltete Bereiche einzeln, gesperrte als eine Station „demnächst".
  const modules = usePortalModules();
  const steps = useMemo(() => buildCustomerTourSteps(modules), [modules]);
  return (
    <GuidedTourShell
      steps={steps}
      openEvent={OPEN_EVENT}
      storageKey={STORAGE_KEY}
      onFinish={() => {
        void completeCustomerTour().catch(() => undefined);
      }}
    />
  );
}
